import React from 'react';
import { UsersIcon } from 'lucide-react';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
import type { EM } from './useEventManager';
export const CapacitySection: React.FC<{
  em: EM;
}> = ({
  em
}) => {
  const dk = useDarkClasses();
  const {
    formData,
    updateField
  } = em;
  return <div className={`p-6 rounded-xl shadow-sm ${dk.card}`} data-id="element-19227" data-mp="30efrqb6uza37">
      <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textHeading}`} data-id="element-19228" data-mp="30g0lvzp9gr0j">
        <UsersIcon className="w-5 h-5 mr-2 text-purple-500" data-id="element-19229" data-mp="1y3gwdrs4ci4" />
        Capacity & Limits
      </h2>

      <div className="space-y-4" data-id="element-19230" data-mp="3t4xufb3o79g3">
        <div data-id="element-19231" data-mp="3obbp63zu67ub">
          <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-19232" data-mp="3oatn2qqhszeh">
            Capacity Limit (Optional)
          </label>
          <input type="number" value={formData.capacityLimit || ''} onChange={e => updateField('capacityLimit', parseInt(e.target.value) || undefined)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} placeholder="Maximum attendees" data-id="element-19233" data-mp="kmrzgt2si5qq" />
        </div>

        <div data-id="element-19234" data-mp="c0uyygph0lgm">
          <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-19235" data-mp="c1ejm56i9nyc">
            Estimated Attendance (Optional)
          </label>
          <input type="number" value={formData.estimatedAttendance || ''} onChange={e => updateField('estimatedAttendance', parseInt(e.target.value) || undefined)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} placeholder="Expected turnout" data-id="element-19236" data-mp="22f8mfy9pg86" />
        </div>

        <div data-id="element-19237" data-mp="1nf8l9h4kssuj">
          <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-19238" data-mp="1nfict959r82c">
            Line Cutoff Policy (Optional)
          </label>
          <textarea rows={2} value={formData.lineCutoffPolicy || ''} onChange={e => updateField('lineCutoffPolicy', e.target.value)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} placeholder="e.g. Lines will be capped 30 mins before end time" data-id="element-19239" data-mp="1q08091z6luz1" />
        </div>
      </div>
    </div>;
};